import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingSystemPages } from "@/data/roofingSystemContent";

const c = roofingSystemPages["luxury-shingle-roofing"];

export const Route = createFileRoute("/services/luxury-shingle-roofing")({
  head: () => ({
    meta: [
      { title: "Luxury Shingle Roofing Southern California | McKay Roofing & Solar" },
      { name: "description", content: c.heroSubtitle },
      { property: "og:title", content: "Luxury Shingle Roofing - McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/luxury-shingle-roofing" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});
